import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UIError } from 'common/interfaces';
import { IUpdateUserState, IUser } from 'common/interfaces/iuser';
import _ from 'lodash';

const initialState: IUpdateUserState = {
  loading: false,
  error: null,
  user: null,
  isUpdated: false,
} as IUpdateUserState;

const reducers = {
  setLoading: (state: IUpdateUserState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IUpdateUserState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IUpdateUserState) => {
    _.merge(state, initialState);
    // state = initialState;
  },

  setUser: (state: IUpdateUserState, action: PayloadAction<IUser | null>) => {
    state.user = action.payload;
  },
  setUpdated: (state: IUpdateUserState, action: PayloadAction<boolean | false>) => {
    state.isUpdated = action.payload;
  },
};

const updateUserSlice = createSlice({
  name: 'IUpdateUserState',
  initialState: initialState,
  reducers: reducers,
});

export default updateUserSlice.reducer;
export const UpdateUserActions = updateUserSlice.actions;
